import React from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useTheme } from "@mui/material";
import { ImageObfuscationCandidate } from "constructs/TaggedImage";
import { TagI, TagId } from "constructs/Tag";
import FormControlLabel from "@mui/material/FormControlLabel";

import Checkbox from "@mui/material/Checkbox";

export interface ImageEditorImageProps {
  width?: string | undefined;
  height?: string | undefined;
}

export interface ImageEditorPreviewProps {
  imgSrc?: string | undefined;
  obfuscations?: Array<ImageObfuscationCandidate> | undefined;
  tags: Array<TagI>;
  ImageProps?: ImageEditorImageProps | undefined;
  assignObfuscationTag: (key: number | string, tagId: number) => any;
  removeObfuscation: (key: number | string) => any;
  resizeObfuscation: (key: number | string) => any;
  onClick?: ((event: any) => void) | undefined;
}

const ImageEditorPreview = ({
  imgSrc,
  obfuscations,
  tags,
  ImageProps,
  onClick,
  assignObfuscationTag,
  removeObfuscation,
  resizeObfuscation,
}: ImageEditorPreviewProps) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<Record<TagId, Element>>({});

  const handleOpenMenu =
    (key: TagId) => (event: React.MouseEvent<Element, MouseEvent>) => {
      event.preventDefault();
      event.stopPropagation();
      setAnchorEl({ ...anchorEl, [key]: event.currentTarget });
    };

  const handleCloseMenu = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl({});
    // enableScrolling(event);
  };

  const disableScrolling = (event: any) => {
    const body = document.getElementsByTagName("body")[0];
    body.style.overflow = "hidden";
  };

  const enableScrolling = (event: any) => {
    const body = document.getElementsByTagName("body")[0];
    body.style.removeProperty("overflow");
  };

  return (
    <Box
      sx={{
        width: "100%",
        border: `1px dotted ${theme.palette.secondary.light}`,
        borderRadius: "10px",
        position: "relative",
      }}
    >
      <svg
        // onDrag
        width={ImageProps?.width}
        height={"100%"}
        style={{ position: "absolute" }}
        // viewBox={`${ImageProps?.width}`}
        onClick={onClick}
      >
        {obfuscations?.map((obfuscation, index) => (
          <React.Fragment key={obfuscation.key}>
            <circle
              key={obfuscation.key}
              cx={obfuscation.cx}
              cy={obfuscation.cy}
              r={obfuscation.r}
              stroke={"blue"}
              strokeWidth={1}
              fill={"pink"}
              onClick={handleOpenMenu(obfuscation.key)}
              onContextMenu={(event) => {
                removeObfuscation(obfuscation.key)(event);
                enableScrolling(event);
              }}
              onMouseEnter={disableScrolling}
              onMouseLeave={enableScrolling}
              onWheel={resizeObfuscation(obfuscation.key)}
              //  style={{ ...updatePartialState() }}
            />
            <Menu
              open={Boolean(anchorEl[obfuscation.key])}
              onClose={handleCloseMenu}
              anchorEl={anchorEl[obfuscation.key]}
            >
              {tags.length ? (
                tags.map((tag, index) => (
                  <MenuItem
                    onClick={(event) => {
                      assignObfuscationTag(
                        obfuscation.key,
                        tag.id as number
                      )(event);
                      // handleCloseMenu(event);
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            Array.isArray(obfuscation.tags) &&
                            obfuscation.tags?.indexOf(tag.id) !== -1
                          }
                        />
                      }
                      label={tag.name}
                    />
                  </MenuItem>
                ))
              ) : (
                <MenuItem onClick={handleCloseMenu}>No Tags</MenuItem>
              )}
            </Menu>
          </React.Fragment>
        ))}
      </svg>
      <img
        onContextMenu={() => false}
        src={imgSrc}
        alt="Uploaded pic"
        width={ImageProps?.width}
        height={ImageProps?.height}
        // onMouseLeave={enableScrolling}
      />
    </Box>
  );
};

export default ImageEditorPreview;
